var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"order-details-barcode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }